import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import { PrinttIcon } from './icons';
import { StyledButton, StyledImg, StyledText } from './styledCommandPanelButton';

const StyledPrintButton = Styled(StyledButton)`
  border: 1px solid #a2b4e8;
  height: 2.5em;
  align-self: flex-end;
  &:hover{
    ${({ disabled }) => !disabled && 'transform: none;'}
    background: #d0f7d4fc;
  }
`;

export function PrintButton({ content, onClick, disabled }) {
  return (
    <StyledPrintButton onClick={onClick} disabled={disabled} title={content}>
      <StyledImg src={PrinttIcon} alt={content} />
      <StyledText>
        {content}
      </StyledText>
    </StyledPrintButton>
  );
}

PrintButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

PrintButton.defaultProps = {
  onClick: () => null,
  content: 'Друк',
  disabled: false,
};

export default PrintButton;
